export default __webpack_public_path__ + "static/media/store_mi.8fb87939.svg";